<template>
    <div class="form-component">
        <v-form :lazy-validation="true" ref="form" v-model="valid">
            <h3 class="form-title">
                <v-btn fab color="primary" @click="close()">
                    <v-icon large>arrow_left</v-icon>
                </v-btn>
                Detalle de Templates
            </h3>
            <v-container fluid class="pa-0">
                <v-layout row wrap>
                    <!-- Column 1 -->
                    <v-flex xs6>
                        <v-layout row wrap>
                            <v-flex xs6>
                                <v-select class="lance"
                                    label="Campo"
                                    v-model="form.field"
                                    :items="fieldItems"
                                    :rules="[v => !!v || 'Campo requerido']"
                                    @input="setPDFPage()"
                                ></v-select>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field class="lance"
                                    label="Referencia"
                                    v-model="form.reference"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                                <v-select class="lance"
                                    label="Posición de referencia"
                                    v-model="form.referencePosition"
                                    :items="referencePositionItems"
                                ></v-select>
                            </v-flex>
                            <v-flex xs6 v-if="form.field == 'Fecha de la Factura'">
                                <v-select class="lance"
                                    label="Formato de Fecha"
                                    v-model="form.dateFormat"
                                    :items="dateFormatItems"
                                    item-text="text"
                                    item-value="value"
                                    :rules="[v => !!v || 'Campo requerido']"
                                ></v-select>
                            </v-flex>

                            <v-flex xs12>
                                <div class="elevation-5 card" :class="{'disabled': !isPosition}" v-if="isPosition">
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                            <h2>Vértices</h2>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field class="lance"
                                                label="X Superior"
                                                v-model="form.posTopX"
                                                type="number"
                                                :rules="posRules"
                                                min="0"
                                                :disabled="!isPosition"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field class="lance"
                                                label="X Inferior"
                                                v-model="form.posBottomX"
                                                type="number"
                                                :rules="posRules"
                                                min="0"
                                                :disabled="!isPosition"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field class="lance"
                                                label="Y Superior"
                                                v-model="form.posTopY"
                                                type="number"
                                                :rules="posRules"
                                                min="0"
                                                :disabled="!isPosition"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field class="lance"
                                                label="Y Inferior"
                                                v-model="form.posBottomY"
                                                type="number"
                                                :rules="posRules"
                                                min="0"
                                                :disabled="!isPosition"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </v-flex>

                            <v-flex xs12>
                                <div class="elevation-5 card" :class="{'disabled': !isNotPosition}" v-if="isNotPosition">
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                            <h2>Celdas</h2>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-select class="lance"
                                                v-model="form.isCellRange"
                                                :items="[{text:'Sí', value:true}, {text:'No', value:false}]"
                                                item-text="text"
                                                item-value="value"
                                                label="Maneja Rangos"
                                                @input="clearDisabled()"
                                                :rules="isNotPosition ? [v => v!=null || 'Campo requerido'] : []"
                                                :disabled="!isNotPosition"
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field class="lance"
                                                v-model="form.rangeStart"
                                                label="Celda inicial"
                                                :rules="isNotPosition && form.isCellRange ? [v => !!v || 'Campo requerido']: []"
                                                :disabled="!isNotPosition || !form.isCellRange"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field class="lance"
                                                v-model="form.cell"
                                                label="Celda"
                                                :rules="isNotPosition && form.isCellRange===false ? [v => !!v || 'Campo requerido']: []"
                                                :disabled="!isNotPosition || form.isCellRange!==false"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field class="lance"
                                                v-model="form.rangeEnd"
                                                label="Celda final"
                                                :rules="isNotPosition && form.isCellRange ? [v => !!v || 'Campo requerido']: []"
                                                :disabled="!isNotPosition || !form.isCellRange"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field class="lance"
                                                v-model="form.cellSheet"
                                                label="Página"
                                                readonly
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </v-flex>
                            
                            <v-flex xs12 v-if="form.field && form.field.startsWith('Tabla de productos')">
                                <div class="elevation-5 card">
                                    <v-layout row wrap>
                                        <v-flex xs12 v-if="isPosition">
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <v-text-field class="lance"
                                                        v-model="form.tableLineHeight"
                                                        label="Altura de linea"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex>
                                                    <v-btn fab small color="primary"
                                                        style="width:40px; height:40px;"
                                                        @click.stop="showTableLineHeightSelect">
                                                        <v-icon>aspect_ratio</v-icon>
                                                        <!-- <img src="@/assets/icon-eliminar.svg" alt=""> -->
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                        <v-flex xs12>
                                            <h2>
                                                Campos de la Tabla
                                                <v-btn
                                                    fab color="primary" 
                                                    @click="addTemplateTableField" 
                                                    style="width:40px; height:40px;"
                                                    :disabled="remainingTableFields.length==0">
                                                    <v-icon>add</v-icon>
                                                </v-btn>
                                            </h2>
                                        </v-flex>
                                        <v-flex xs12 class="overflow-x-auto">
                                            <table class="v-datatable v-table theme--light">
                                                <thead>
                                                    <tr class="" style="height: auto;">
                                                        <th class="text-xs-left pt-0 pb-2">Columna</th>
                                                        <th class="text-xs-left pt-0 pb-2">Referencia</th>
                                                        <th class="text-xs-left pt-0 pb-2">Opcional</th>
                                                        <th class="text-xs-left pt-0 pb-2">Formato</th>
                                                        <th class="text-xs-left pt-0 pb-2">{{isPosition	? "Posición": "Columna"}}</th>
                                                        <th class="text-xs-left pt-0 pb-2" style="max-width: 30px;"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, idx) in form.templateTableFields" :key="idx" @click="editTableField(idx)">
                                                        <td class="text-xs-left">{{ item.field }}</td>
                                                        <td class="text-xs-left">{{ item.reference }}</td>
                                                        <td class="text-xs-left">{{ item.isOptional? "Sí": "No" }}</td>
                                                        <td class="text-xs-left">{{ item.format }}</td>
                                                        <td v-if="isPosition" class="text-xs-left">{{ `${item.x1} a ${item.x2}` }}</td>
                                                        <td v-if="isNotPosition" class="text-xs-left">{{ item.column }}</td>
                                                        <td class="px-0" style="max-width: 30px;">
                                                            <v-btn fab small color="error"
                                                                style="width: 30px; height: 30px;"
                                                                @click.stop="removeTableField(idx)">
                                                                <img src="@/assets/icon-eliminar.svg" alt="">
                                                            </v-btn>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </v-flex>

                            <v-flex xs6>
                                <v-btn v-if="!view" solo color="submitBtn" @click="save()" :disabled="!valid">Guardar</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <!-- Column 2 -->
                    <v-flex xs6 class="document-column">
                        <v-layout column>
                            <v-flex>
                                <h3 class="text-xs-center">
                                    Documento
                                </h3>
                            </v-flex>
                            <!-- display document images -->
                            <v-flex v-if="imageSources && imageSources.length">
                                <div class="elevation-5 card">
                                    <h6 class="text-xs-center" v-if="imageSources[0]=='loading'">Cargando...</h6>
                                    <ImageSelect
                                        v-if="imageSources[0] != 'loading'"
                                        style="width:100%;" 
                                        v-model="coords"
                                        :imgSrc="imageSources[currentPage]"/>
                                </div>
                            </v-flex>
                            <v-flex v-if="imageSources && imageSources.length" align-self-center>
                                <v-btn fab color="primary" @click="currentPage--" :disabled="currentPage<=0">
                                    <v-icon>arrow_left</v-icon>
                                </v-btn>
                                <span>Página {{currentPage+1}} / {{imageSources.length}}</span>
                                <v-btn fab color="primary" @click="currentPage++" :disabled="currentPage>=imageSources.length-1">
                                    <v-icon>arrow_right</v-icon>
                                </v-btn>
                            </v-flex>
                            <!-- Display spreadsheet -->
                            <v-flex v-if="workbook">
                                <WorkbookGrid
                                    @input="updateFormCell"
                                    v-if="workbook"
                                    :worksheet="workbook.Sheets[workbook.SheetNames[currentPage]]"/>
                            </v-flex>
                            <v-flex v-if="workbook" align-self-center>
                                <v-btn 
                                    fab color="primary"
                                    @click="form.cellSheet = workbook.SheetNames[--currentPage];"
                                    :disabled="currentPage<=0">
                                    <v-icon>arrow_left</v-icon>
                                </v-btn>
                                <span>Página {{currentPage+1}} / {{workbook.SheetNames.length}}</span>
                                <v-btn 
                                    fab color="primary" 
                                    @click="form.cellSheet = workbook.SheetNames[++currentPage];" 
                                    :disabled="currentPage>=workbook.SheetNames.length-1">
                                    <v-icon>arrow_right</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>

        <TableFieldModal v-if="tableFieldDialog"
            v-model="tableFieldDialog"
            :imageSelection="imageSelection"
            :imageSources="imageSources"
            :isPosition="isPosition"
            :remainingTableFields="remainingTableFields"
            :editData="tempTableFieldData"
            @add="addTableFieldDialog"
            @edit="onEditTableFieldDialog"
            @cancel="cancelTableFieldDialog"
        ></TableFieldModal>

        <v-dialog v-model="tableLineHeightDialog" max-width="900">
            <div class="elevation-5 card" style="margin: 0;">
                <v-layout column>
                    <v-flex>
                        <h2>Seleccionar altura de linea en tabla de productos</h2>
                    </v-flex>
                    <v-flex>
                        <v-text-field
                            class="lance"
                            label="Altura actual"
                            :value="Math.abs(lineHeightCoords.y2-lineHeightCoords.y1)"
                            readonly
                        ></v-text-field>
                    </v-flex>
                    <v-flex>
                        <ImageSelect
                            v-if="imageSelection"
                            style="width:100%;" 
                            v-model="lineHeightCoords"
                            :imgSrc="imageSelection"/>
                    </v-flex>
                    <v-flex style="display: flex;">
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" flat @click="cancelTableLineHeightDialog">Cancelar</v-btn>
                        <v-btn
                            solo
                            color="submitBtn"
                            @click="setTableLineHeightDialog"
                            style="color: white;"
                            >Aceptar</v-btn>
                    </v-flex>
                </v-layout>
            </div>
        </v-dialog>
    </div>
</template>

<script>
import ImageSelect from "./ImageSelect";
import WorkbookGrid from "./WorkbookGrid";
import TableFieldModal from "./tableFieldModal.vue";
export default {
    props: {
        initialField: Object,
        usedFields: Array,
        imageSources: Array,
        workbook: Object,
        fieldOptions: Array,
        tableFieldOptions: Array,
        isPosition: Boolean,
    },
    data() {
        return {
            valid: null,
            view: false,
            form: Object.assign({
                posTopX: null,
                posTopY: null,
                posBottomX: null,
                posBottomY: null,
                cell: null,
                templateTableFields: [],
            }, this.initialField || {}),
            referencePositionItems: [
                "Referencia al inicio",
                "Referencia a la mitad",
                "Referencia al final",
                "Referencia que contiene",
            ],
            dateFormatItems: [
                { text: 'Dia / Mes / Año', value: 'D/M/YYYY' },
                { text: 'Mes / Dia / Año', value: 'M/D/YYYY' },
                { text: 'Año / Mes / Dia', value: 'YYYY/M/D' },
                { text: 'Mes / Año', value: 'M/YYYY' },
                { text: 'Dia / Mes Completo / Año', value: 'D/MMMM/YYYY' },
                { text: 'Mes Completo / Dia / Año', value: 'MMMM/D/YYYY' },
                { text: 'Año / Mes Completo / Dia', value: 'YYYY/MMMM/D' },
                { text: 'Mes Completo / Año', value: 'MMMM/YYYY' },
            ],
            fieldItems: this.fieldOptions || [],
            currentPage: 0,
            coords: {
                x1: this.initialField? this.initialField.posTopX: null,
                y1: this.initialField? this.initialField.posTopY: null,
                x2: this.initialField? this.initialField.posBottomX: null,
                y2: this.initialField? this.initialField.posBottomY: null,
            },
            lineHeightCoords: {
                x1: 0, y1: 0, x2: 0, y2: 0
            },
            imageSelection: null,
            tableLineHeightDialog: false,
            tableFieldDialog: false,
            tableFieldItems: this.tableFieldOptions || [],
            tempTableFieldData: null,
            tempTableFieldIdx: null,
        }
    },
    methods: {
        snack(msg, option=null) {
            events.$emit('snackbar', msg, options);
        },
        clearDisabled() {
            if (this.form.isCellRange) {
                this.form.cell = null;
            } else {
                this.form.rangeStart = null;
                this.form.rangeEnd = null;
            }
        },
        updateFormCell(value) {
            if (this.isNotPosition && this.form.isCellRange===false) {
                this.form.cell = value;
            }
        },

        /* select table line height modal functions */
        showTableLineHeightSelect() {
            this.tableLineHeightDialog = true;
            this.updateImageSelection(0, this.coords.y1 - 40, "fullwidth", this.coords.y2 + 300);
        },
        cancelTableLineHeightDialog() {
            this.tableLineHeightDialog = false;
            this.lineHeightCoords.y1 = 0;
            this.lineHeightCoords.y2 = 0;
        },
        setTableLineHeightDialog() {
            this.tableLineHeightDialog = false;

            this.form.tableLineHeight = Math.abs(this.lineHeightCoords.y2 - this.lineHeightCoords.y1);
        },

        /* add table field modal functions */
        addTemplateTableField(e) {
            this.tableFieldDialog = true;
            this.tempTableFieldData = null;
            this.tempTableFieldIdx = null;
            if (this.isPosition) {
                this.updateImageSelection(0, this.coords.y1 - 40, "fullwidth", this.coords.y2 + 300);
            }
        },
        cancelTableFieldDialog() {
            this.tableFieldDialog = false;
        },
        addTableFieldDialog(tableField) {
            this.tableFieldDialog = false;
            this.form.templateTableFields.push(tableField);
        },
        editTableField(idx) {
            this.tableFieldDialog = true;
            this.tempTableFieldData = this.form.templateTableFields[idx];
            this.tempTableFieldIdx = idx;
            if (this.isPosition) {
                this.updateImageSelection(0, this.coords.y1 - 40, "fullwidth", this.coords.y2 + 300);
            }
        },
        onEditTableFieldDialog(tableField) {
            this.tableFieldDialog = false;
            this.form.templateTableFields[this.tempTableFieldIdx] = tableField;
            this.tempTableFieldData = null;
            this.tempTableFieldIdx = null;
        },
        removeTableField(idx) {
            this.form.templateTableFields.splice(idx, 1);
        },

        /* misc functions */
        updateImageSelection(x1, y1, x2, y2) {
            if (this.imageSources.length == 0) return;
            let img = new Image();
            img.src = this.imageSources[this.currentPage];
            if (x2 == "fullwidth" || x2 > img.width)
                x2 = img.width;
            if (y2 == "fullheight" || y2 > img.height)
                y2 = img.height
            
            let c = document.createElement("canvas");
            let ctx = c.getContext("2d", {alpha: false});
            let w = c.width = Math.abs(x2 - x1);
            let h = c.height = Math.abs(y2 - y1);
            img.onload = () => {
                // (image, imgXi,imgYi,imgW,imgH, Xd,Yd,w,h)
                ctx.drawImage(img, x1, y1, w, h, 0, 0, w, h);
                this.imageSelection = c.toDataURL();
            }
        },
        setPDFPage() {
            if(this.form.field === 'Total de la factura'){
                this.currentPage = this.imageSources.length - 1;
            }
        },
        
        /* functions to close component */
        save() {
            if(this.$refs.form.validate()){
                if (this.initialField) {
                    this.$emit("edit", this.form);
                } else {
                    this.$emit("add", this.form);
                }
                this.close();
            }
        },
        close() {
            this.$emit("close");
        },
    },
    mounted() {
        let supplierCode = this.$router.id;
        if (this.initialField) {
            this.fieldItems = this.fieldItems.filter(x => this.initialField.field == x || !this.usedFields.some(y => y == x));
        } else {
            this.fieldItems = this.fieldItems.filter(x => !this.usedFields.some(y => y == x));
        }

        // for excel forms we dont include fields "Tabla de productos hoja intermedia" and "Tabla de productos hoja final"
        if (this.isNotPosition) {
            this.fieldItems = this.fieldItems.filter(x => 
                x != 'Tabla de productos hoja intermedia' && x != 'Tabla de productos hoja final');
        }

        if (this.isNotPosition && this.workbook) {
            if (!this.form.cellSheet) {
                this.form.cellSheet = this.workbook.SheetNames[this.currentPage];
            } else {
                let i = this.workbook.SheetNames.indexOf(this.form.cellSheet)
                this.currentPage = (i != -1) ? i : 0;
            }
        }
        if(this.form.field === 'Total de la factura' && this.imageSources.length){
            this.currentPage = this.imageSources.length - 1;
        }
    },
    computed: {
        isNotPosition: {
            get() {
                return !this.isPosition;
            },
            set(v) {
                this.isPosition = !v;
            },
        },
        posRules() {
            let rules = [v => v>=0 || 'Este campo no puede ser negativo'];
            if (this.isPosition) 
                rules.push(v => !!v || v===0 || 'Campo requerido');
            return rules;
        },
        remainingTableFields() {
            let result = this.tableFieldItems.filter(
                i => !this.form.templateTableFields.some(
                    (j, idx) => this.tempTableFieldIdx != idx && j.field == i
                )
            );
            return result;
        }
    },
    watch: {
        "coords.x1": function(newVal) { this.form.posTopX = newVal; },
        "coords.y1": function(newVal) { this.form.posTopY = newVal; },
        "coords.x2": function(newVal) { this.form.posBottomX = newVal; },
        "coords.y2": function(newVal) { this.form.posBottomY = newVal; },
        "form.posTopX": function(newVal) { this.coords.x1 = newVal; },
        "form.posTopY": function(newVal) { this.coords.y1 = newVal; },
        "form.posBottomX": function(newVal) { this.coords.x2 = newVal; },
        "form.posBottomY": function(newVal) { this.coords.y2 = newVal; },
        "tableFieldDialog": function(newVal) {
            if (newVal) {
                document.body.classList.add('no-scroll');
            } else {
                document.body.classList.remove('no-scroll');
            }
        },
        "imageSources": function(newVal) { 
            if(this.form.field === 'Total de la factura'){
                this.currentPage = this.imageSources.length - 1;
            }
        }
    },
    components: {
        ImageSelect,
        WorkbookGrid,
        TableFieldModal,
    },
}
</script>

<style scoped>
    .overflow-x-auto {
        overflow-x: auto;
    }
    .layout {
        margin: -8px !important;
    }
    .flex {
        padding: 8px !important;
    }
    .document-column {
        padding-left: 50px !important;
    }
    .card {
        background-color: white;
        border-radius: 16px;
        margin-bottom: 28px;
        padding: 40px;
    }
    .card.disabled {
        opacity: 0.6;
    }
    .v-input.v-input--switch {
        display: inline-flex;
    }

    .theme--light.v-table thead th {
        font-weight: bold;
    }

    .v-table tbody tr {
        cursor: pointer;
    }
</style>
